import { ThemePalette, getTheme } from '../themes/theme';

export const Palette: ThemePalette = new Proxy({} as ThemePalette, {
  get: (_target, property: string) => getTheme().palette[property as keyof ThemePalette],
});
